import { faCircleCheck } from "@fortawesome/free-solid-svg-icons";
import pluralize from "pluralize";

import Icon from "@/components/atoms/media/Icon";

import { PHONE_LINK, PHONE_NUMBER_DISPLAY } from "../utils/constants";
import formStyles from "./CreateYourOwnForm.module.css";
import { CreateYourOwnPersonalFormData } from "./CreateYourOwnPersonalForm";
import styles from "./CreateYourOwnResult.module.css";
import { CreateYourOwnTravelFormData } from "./CreateYourOwnTravelForm";

interface CreateYourOwnSuccessViewProps {
  travelDetails: CreateYourOwnTravelFormData | null;
  personalDetails: CreateYourOwnPersonalFormData | null;
  venueName?: string;
  onClose: () => void;
}

function formatDate(date: string) {
  return new Date(date).toLocaleDateString("en-GB").replace(/\//g, "-");
}

function CreateYourOwnSuccessView(props: CreateYourOwnSuccessViewProps) {
  const { travelDetails, personalDetails, venueName, onClose } = props;

  return (
    <div className={styles.wrapper}>
      <button
        type="button"
        className={styles.closeButton}
        onClick={onClose}
        aria-label="Close modal"
      >
        ×
      </button>
      <div className={formStyles.summaryHeader}>
        <h3>{venueName || "Golf Break"}</h3>
        <p>
          {pluralize("Nights", parseInt(travelDetails?.nights ?? "0"), true)},{" "}
          {pluralize("Round", parseInt(travelDetails?.rounds ?? "0"), true)} on{" "}
          {travelDetails?.arrival_date &&
            formatDate(travelDetails?.arrival_date)}
        </p>
      </div>

      <section>
        <div className={styles.checkmarkContainer}>
          <Icon name={faCircleCheck} />
        </div>

        <article>
          <h2>Thank you, {personalDetails?.first_name?.split(" ")[0]}</h2>

          <p>
            We've received your enquiry, thanks! You are now just moments away
            from a great golf holiday.
          </p>

          <p>
            The next step is one of our Golf Travel Experts (who will have
            played the golf courses) will be in touch to organise the perfect
            trip for you.
          </p>

          <p>
            If your enquiry is urgent, we recommend you call{" "}
            <a href={PHONE_LINK}>{PHONE_NUMBER_DISPLAY}</a> where our Golf
            Travel Experts can help you within 60 seconds.
          </p>
        </article>
      </section>
    </div>
  );
}

export default CreateYourOwnSuccessView;
export { CreateYourOwnSuccessView, type CreateYourOwnSuccessViewProps };
